module.exports = __webpack_public_path__ + "img/Eventsly.5bf5dce6.png";